import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, CircularProgress, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLogin } from "../../Hooks/useLogin";
import { LoginFormType } from "../../Schemas/LoginSchemas";
import { ProfileType } from "../../Types/General";
import { LoginLayout } from "../../Shared Components/Kazi/Layouts/LoginLayout";

interface IProps {}

export const AdminLogin = ({}:IProps) => {
    /* ******************** Hooks ******************** */
    const { login, loginLoading } = useLogin(ProfileType.Admin);
    const {
        handleSubmit, 
        control, 
        formState: {isDirty}
    } = useForm<LoginFormType>({
        defaultValues: {
            user_login: '',
            password: ''
        }
    })
    /* ******************** Variables ******************** */
    const [showPassword, setShowPassword] = useState(false);
    /* ******************** Functions ******************** */
    const onSubmit = (data: LoginFormType) => {
        login({ user_login: data.user_login!, password: data.password!});
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <LoginLayout>
            <Typography variant="body-large" marginBottom={"30px"}>Enter admin credentials</Typography>
            <Controller
                name="user_login"
                control={control} 
                render={({field})=>(
                    <TextField
                        {...field}
                        placeholder="Email"
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    />
                )}
            />
            <Controller
                name="password"
                control={control} 
                render={({field})=>(
                    <TextField
                        {...field}
                        placeholder="Password"
                        type={!showPassword?"Password":"text"}
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                        onKeyDown={(event) => {
                            if (event.code === 'Enter') handleSubmit(onSubmit)()
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <Visibility color="primary"/> : <VisibilityOff color="primary"/>}
                                </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                )}
            />
            <Button 
                variant="contained" 
                disabled={!isDirty} 
                size="large" 
                onClick={handleSubmit(onSubmit)}
                endIcon={ loginLoading ? <CircularProgress color="secondary" size={"18px"}/> :null} 
            >
                { loginLoading ? "Logging in..." : "Log in"}
            </Button>
        </LoginLayout>
    )
}